export const SAVED_PLAN_STORAGE_KEY = "pw-saved-plan";
export const WORKOUT_CHECKS_STORAGE_KEY = "pw-workout-checks";

/** @returns {{ formData: object, planWeeks: array, savedAt: string } | null} */
export function readSavedPlan() {
  try {
    const raw = localStorage.getItem(SAVED_PLAN_STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (
        parsed?.formData &&
        Array.isArray(parsed.planWeeks) &&
        parsed.planWeeks.length > 0
      ) {
        return parsed;
      }
    }
    const legacyForm = localStorage.getItem("pacewerksFormData");
    const legacyWeeks = localStorage.getItem("pacewerksPlanWeeks");
    if (legacyForm && legacyWeeks) {
      const formData = JSON.parse(legacyForm);
      const planWeeks = JSON.parse(legacyWeeks);
      if (formData && Array.isArray(planWeeks) && planWeeks.length > 0) {
        return {
          formData,
          planWeeks,
          savedAt: null,
        };
      }
    }
  } catch {
    /* ignore parse / quota */
  }
  return null;
}

export function hasSavedPlan() {
  return readSavedPlan() != null;
}

export function readWorkoutChecks() {
  try {
    const raw = localStorage.getItem(WORKOUT_CHECKS_STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

export function saveWorkoutChecks(checks) {
  try {
    localStorage.setItem(WORKOUT_CHECKS_STORAGE_KEY, JSON.stringify(checks));
  } catch {
    /* ignore quota / private mode */
  }
}

export function clearWorkoutChecks() {
  try {
    localStorage.removeItem(WORKOUT_CHECKS_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function saveSavedPlan(formData, planWeeks) {
  clearWorkoutChecks();
  const payload = {
    formData,
    planWeeks,
    savedAt: new Date().toISOString(),
  };
  try {
    localStorage.setItem(SAVED_PLAN_STORAGE_KEY, JSON.stringify(payload));
    localStorage.setItem("pacewerksFormData", JSON.stringify(formData));
    localStorage.setItem("pacewerksPlanWeeks", JSON.stringify(planWeeks));
  } catch {
    /* ignore quota / private mode */
  }
  return payload.savedAt;
}

export function formatPlanSavedDate(isoString) {
  if (!isoString) return null;
  const d = new Date(isoString);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
}
